import React from 'react';
import { useTranslation } from 'react-i18next';
import BaseScadaNode from './BaseScadaNode';

export function PackagerDoypakSVG({ value, config = {}, width = 120, height = 55 }) {
    const running = parseFloat(value) >= (parseFloat(config.threshold ?? 0.5));
    const color = running ? (config.run_color || '#22C55E') : (config.stop_color || '#64748B');
    const cy = height / 2;
    const bodyH = height * 0.6;
    const bodyY = cy - bodyH / 2;

    return (
        <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} style={{ display: 'block' }}>
            {/* Film reel top */}
            <circle cx={12} cy={10} r={8} fill="#1E293B" stroke={color} strokeWidth={1.5} />
            <circle cx={12} cy={10} r={4} fill="#334155" />
            {/* Machine body (horizontal) */}
            <rect x={20} y={bodyY} width={width - 40} height={bodyH} rx={6} fill="#1E293B" stroke={color} strokeWidth={2} />
            {/* Pouch shapes in sequence */}
            {[0, 1, 2].map(i => {
                const px = 26 + i * ((width - 52) / 3);
                const pw = (width - 52) / 3 - 4;
                const ph = bodyH - 10;
                const py = bodyY + 5;
                return (
                    <g key={i}>
                        <path
                            d={`M ${px + 4},${py} L ${px + pw - 4},${py} L ${px + pw},${py + ph} Q ${px + pw / 2},${py + ph + 6} ${px},${py + ph} Z`}
                            fill={i === 2 ? color : '#334155'}
                            stroke={color}
                            strokeWidth={1}
                            opacity={0.8}
                        />
                    </g>
                );
            })}
            {/* Flow arrow (right) */}
            <text x={width - 12} y={cy + 5} textAnchor="middle" fill={color} fontSize={12}>→</text>
            {/* Drive/sensor */}
            <rect x={width - 20} y={bodyY} width={12} height={bodyH} rx={3} fill="#334155" stroke={color} strokeWidth={1.5} />
        </svg>
    );
}

export default function PackagerDoypakNode(props) {
    const { data } = props;
    const { t } = useTranslation();
    const liveValues = data?.liveValues || {};
    const threshold  = parseFloat(data?.config?.threshold ?? 0.5);
    const requesting = liveValues.requesting_product != null
        && parseFloat(liveValues.requesting_product) >= threshold;
    const bufferEmpty = !!liveValues._packagerBufferEmpty;
    const running = parseFloat(liveValues.state ?? 0) >= threshold;
    return (
        <BaseScadaNode {...props}>
            <PackagerDoypakSVG
                value={liveValues.state ?? data?.liveValue}
                config={data?.config}
                width={data?.width || 120}
                height={data?.height || 55}
            />
            {running && bufferEmpty && (
                <div style={{ position: 'absolute', top: 4, left: 4, right: 4, background: '#7F1D1D',
                    border: '1px solid #EF4444', borderRadius: 4, padding: '2px 4px',
                    fontSize: 9, color: '#FCA5A5', textAlign: 'center', fontWeight: 600,
                    pointerEvents: 'none', zIndex: 5 }}>
                    {t('scada.noProduct')}
                </div>
            )}
            {running && requesting && !bufferEmpty && (
                <div style={{ position: 'absolute', top: 4, left: 4, right: 4, background: '#92400E',
                    border: '1px solid #F59E0B', borderRadius: 4, padding: '2px 4px',
                    fontSize: 9, color: '#FEF3C7', textAlign: 'center', fontWeight: 600,
                    pointerEvents: 'none', zIndex: 5 }}>
                    {t('scada.sig.requestingProduct')}
                </div>
            )}
            {data?.label && (
                <div style={{ textAlign: 'center', fontSize: 10, color: '#94A3B8', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                    {data.label}
                </div>
            )}
        </BaseScadaNode>
    );
}
